import React from "react";

type FormData = {
  Candidate: {
    CandidateID: string;
  };
  Interview: {
    StartDateTime: string;
    EndDateTime: string;
  };
  JobRequisition: {
    JobRequisitionID: string;
  };
  EI: {
    EIEnterpriseID: string;
  }[];
};

type ScheduleFormProps = {
  formData: FormData;
  submitLoading: boolean;
  handleChange: (
    e: React.ChangeEvent<HTMLInputElement>,
    section: keyof FormData,
    field: string,
    index?: number
  ) => void;
  getMinDateTime: () => string;
};

const ScheduleForm: React.FC<ScheduleFormProps> = ({
  formData,
  submitLoading,
  handleChange,
  getMinDateTime,
}) => {
  const styles = {
    field: {
      display: "flex",
      flexDirection: "column",
    } as React.CSSProperties,
    label: {
      fontSize: "15px",
      fontWeight: 600,
      color: "#333",
      marginBottom: "6px",
    } as React.CSSProperties,
    input: {
      width: "100%",
      padding: "10px 12px",
      border: "1px solid #ccc",
      borderRadius: "8px",
      fontSize: "14px",
      outline: "none",
    } as React.CSSProperties,
  };

  const isFormValid = (): boolean => {
    return (
      formData.Candidate.CandidateID.trim() !== "" &&
      formData.Interview.StartDateTime.trim() !== "" &&
      formData.Interview.EndDateTime.trim() !== "" &&
      formData.JobRequisition.JobRequisitionID.trim() !== "" &&
      formData.EI.every((ei) => ei.EIEnterpriseID.trim() !== "")
    );
  };

  return (
    <div style={{ padding: 24 }}>
      <div style={{ display: "grid", marginBottom: "24px" }}>
        <div style={{ display: "flex", gap: "10px" }}>
          <div style={{ ...styles.field, flex: 1 }}>
            <label style={styles.label}>Candidate ID</label>
            <input
              disabled={submitLoading}
              type="text"
              value={formData.Candidate.CandidateID}
              onChange={(e) => handleChange(e, "Candidate", "CandidateID")}
              style={styles.input}
            />
          </div>
        </div>
      </div>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: "20px",
          marginBottom: 24,
        }}
      >
        <div style={styles.field}>
          <label style={styles.label}>Start Date & Time</label>
          <input
            disabled={submitLoading}
            type="datetime-local"
            min={getMinDateTime()}
            value={formData.Interview.StartDateTime.slice(0, 16)}
            onChange={(e) => handleChange(e, "Interview", "StartDateTime")}
            style={styles.input}
          />
        </div>
        <div style={styles.field}>
          <label style={styles.label}>End Date & Time</label>
          <input
            disabled={submitLoading}
            type="datetime-local"
            min={getMinDateTime()}
            value={formData.Interview.EndDateTime.slice(0, 16)}
            onChange={(e) => handleChange(e, "Interview", "EndDateTime")}
            style={styles.input}
          />
        </div>
      </div>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr",
          marginBottom: 24,
        }}
      >
        <div style={styles.field}>
          <label style={styles.label}>Job Requisition ID</label>
          <input
            type="text"
            value={formData.JobRequisition.JobRequisitionID}
            onChange={(e) =>
              handleChange(e, "JobRequisition", "JobRequisitionID")
            }
            disabled={submitLoading}
            style={styles.input}
          />
        </div>
      </div>
      {formData.EI.map((ei, idx) => (
        <div
          key={idx}
          style={{
            display: "grid",
            gridTemplateColumns: "1fr",
            marginBottom: 24,
          }}
        >
          <div style={styles.field}>
            <label style={styles.label}>Interviewer Email</label>
            <input
              disabled={submitLoading}
              type="email"
              value={ei.EIEnterpriseID}
              onChange={(e) => handleChange(e, "EI", "EIEnterpriseID", idx)}
              style={styles.input}
            />
          </div>
        </div>
      ))}
      <div style={{ textAlign: "right" }}>
        <button
          type="submit"
          disabled={submitLoading || !isFormValid()}
          style={{
            backgroundColor:
              submitLoading || !isFormValid() ? "#94a3b8" : "#2563eb",
            color: "#fff",
            padding: "12px 24px",
            border: "none",
            borderRadius: "8px",
            fontSize: "16px",
            fontWeight: 600,
            cursor: submitLoading || !isFormValid() ? "not-allowed" : "pointer",
          }}
        >
          {submitLoading ? "Submitting..." : "Submit"}
        </button>
      </div>
    </div>
  );
};

export default ScheduleForm;
